import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import { GeolocationProvider } from './contexts/GeolocationContext';

// Configurar React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos
      gcTime: 10 * 60 * 1000, // 10 minutos (cacheTime renombrado a gcTime en React Query v5)
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
    },
  },
});

// Log global de errores (solo producción)
if (import.meta.env.PROD) {
  window.addEventListener('error', (e) => {
    console.error('[GlobalError]', e.message, e.error?.stack || '');
  });
  window.addEventListener('unhandledrejection', (e) => {
    console.error('[PromiseRejection]', e.reason);
  });
}


const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
]);

// ✅ CORRECCIÓN: StrictMode deshabilitado debido a un error conocido de @hello-pangea/dnd v18.0.1
// El error "Failed to execute 'removeChild' on 'Node'" ocurre por el double-mounting en desarrollo
// y no tiene solución hasta que se lance una versión más reciente de la librería.
// Esto no afecta la funcionalidad ni la detección de otros bugs en desarrollo.
// Ref: https://github.com/hello-pangea/dnd/issues
ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <GeolocationProvider>
      <RouterProvider router={router} />
    </GeolocationProvider>
  </QueryClientProvider>,
);